var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _g, _g2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgfilter1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 285,
  height: 140,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFEFF",
  d: "M91 41.44h142.29V123a4 4 0 0 1-4 4H95a4 4 0 0 1-4-4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M91 36a2 2 0 0 1 2-2h138.29a2 2 0 0 1 2 2v5.44H91z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 23.25,
  height: 23.25,
  x: 135.94,
  y: 52,
  fill: "#D9D9D9",
  rx: 2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 23.25,
  height: 23.25,
  x: 135.94,
  y: 91.99,
  fill: "#D9D9D9",
  rx: 2
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 23.25,
  height: 23.25,
  x: 165.7,
  y: 91.99,
  fill: "#D9D9D9",
  rx: 2
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 23.25,
  height: 23.25,
  x: 195.46,
  y: 91.99,
  fill: "#D9D9D9",
  rx: 2
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 23.25,
  height: 23.25,
  x: 165.7,
  y: 52,
  fill: "#D9D9D9",
  rx: 2
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 23.25,
  height: 23.25,
  x: 195.46,
  y: 52,
  fill: "#D9D9D9",
  rx: 2
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 57.527,
  height: 99,
  x: 72,
  y: 20,
  fill: "#008060",
  rx: 2
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 13.665,
  height: 9.428,
  x: 78.689,
  y: 28.027,
  fill: "#FFFEFF",
  rx: 1
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 13.665,
  height: 9.428,
  x: 78.689,
  y: 39.813,
  fill: "#FFFEFF",
  opacity: 0.4,
  rx: 1
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 13.378,
  height: 5.351,
  x: 77.352,
  y: 84.217,
  fill: "#FFFEFF",
  rx: 1
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 29.432,
  height: 4.014,
  x: 77.352,
  y: 92.244,
  fill: "#fff",
  opacity: 0.4,
  rx: 1
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 21.405,
  height: 4.014,
  x: 77.352,
  y: 98.934,
  fill: "#fff",
  opacity: 0.4,
  rx: 1
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 12.614,
  height: 9.428,
  x: 94.457,
  y: 28.027,
  fill: "#FFFEFF",
  opacity: 0.4,
  rx: 1
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  width: 12.614,
  height: 9.428,
  x: 94.457,
  y: 39.813,
  fill: "#FFFEFF",
  opacity: 0.4,
  rx: 1
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  width: 13.665,
  height: 9.428,
  x: 109.173,
  y: 28.027,
  fill: "#FFFEFF",
  opacity: 0.4,
  rx: 1
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  width: 13.665,
  height: 9.428,
  x: 109.173,
  y: 39.813,
  fill: "#FFFEFF",
  opacity: 0.4,
  rx: 1
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#F0F1F2",
  clipPath: "url(#img_filter1_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 81.315,
  cy: 63.012,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91.039,
  cy: 63.012,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100.763,
  cy: 63.012,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110.487,
  cy: 63.012,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120.211,
  cy: 63.012,
  r: 3
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#F0F1F2",
  clipPath: "url(#img_filter1_svg__b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 81.315,
  cy: 73.686,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91.039,
  cy: 73.686,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100.763,
  cy: 73.686,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110.487,
  cy: 73.686,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120.211,
  cy: 73.686,
  r: 3
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABEC3",
  d: "M254.249 17.8c.249 0 .452.222.452.494v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.494.452-.494M254.249 14c.249 0 .452.221.452.493v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.493.452-.493M251.452 16.986h1.788c.249 0 .452.222.452.494 0 .271-.203.493-.452.493h-1.788c-.249 0-.452-.222-.452-.493 0-.272.203-.494.452-.494M255.258 16.986h1.788c.249 0 .452.222.452.494 0 .271-.203.493-.452.493h-1.788c-.249 0-.452-.222-.452-.493 0-.272.203-.494.452-.494M32.25 119.8c.248 0 .451.222.451.494v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.494.452-.494M32.25 116c.248 0 .451.221.451.493v2.172c0 .272-.203.493-.452.493s-.452-.221-.452-.493v-2.172c0-.272.203-.493.452-.493M29.452 118.986h1.788c.249 0 .452.222.452.493 0 .272-.203.494-.452.494h-1.788c-.249 0-.452-.222-.452-.494 0-.271.203-.493.452-.493M33.258 118.986h1.788c.249 0 .452.222.452.493 0 .272-.203.494-.452.494h-1.788c-.249 0-.452-.222-.452-.494 0-.271.203-.493.452-.493M253 114a1 1 0 1 0 2 0 1 1 0 1 0-2 0M37 46.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "img_filter1_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M78.315 59.01h44.895v8.005H78.315z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "img_filter1_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M78.315 69.684h44.895v8.005H78.315z"
})))));
export { SvgImgfilter1 as ReactComponent };
export default __webpack_public_path__ + "static/media/img.filter1.1b53c657.svg";